<script>  
  import Saos from 'saos/src/Saos.svelte';
</script>

<div class="swap_section" id="buy">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6 text-center">        
          <img src="/img/images/swap.png" alt="dog coin" class="img-fluid swap_img"/>            
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="common_home_section">
            <h2>How To Buy</h2>
            <p>DOE is the Governance token for the Dogs of Elon ecosystem. It is available on multiple centralized exchanges (CEX) such as Gate, Poloniex, MEXC and more.<br/><br/>
              DOE is also available on decentralized exchanges (DEX) such as Uniswap and Sushiswap.<br/><br/>
              We believe in full transparency and security of our token and ecosystem, and for that reason we have <a href="https://app.unicrypt.network/amm/uni-v2/pair/0xa626eb9cc7dec00703586414d0811e1ba2021443" target="_blank">locked</a> 99.9% of the liquidity on Uniswap.<br/><br/>              
            </p>
            <div class="btn_group">                   
              <a href="https://app.uniswap.org/#/swap?outputCurrency=0xf8e9f10c22840b613cda05a0c5fdb59a4d6cd7ef" target="_blank" rel="noreferrer" class="outline_btn">Buy on UniSwap</a>
              <a href="https://app.sushi.com/swap?inputCurrency=&outputCurrency=0xE71Db7a96daB25cDb9f4cbC7F686da02192B0E88" target="_blank" rel="noreferrer" class="outline_btn">Buy on Arbitrum</a>
            </div>
            <div class="exchanges_div">
              <h3>Exchanges</h3>
              <div>
                <a href="https://www.gate.io/trade/DOE_USDT">
                  <img class="normal_social" src="/img/images/gate_logo.svg" alt="Icon"/>
                  <img class="hover_socail" src="/img/images/gate_logo_hover.svg" alt="Icon"/>                        
                </a>
                <a href="https://poloniex.com/exchange/USDT_DOE">
                  <img class="normal_social" src="/img/images/plonix.svg" alt="Icon"/>
                  <img class="hover_socail" src="/img/images/plonix_hover.svg" alt="Icon"/>
                </a>
                <a href="https://www.mexc.com/exchange/DOE_USDT">
                  <img class="normal_social" src="/img/images/mexc.svg" alt="Icon"/>
                  <img class="hover_socail" src="/img/images/mexc_hover.svg" alt="Icon"/>
                </a>                    
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>